export const GUEST_CHECKOUT_KEY = 'guest-checkout-key';

export const RETURNING_CUSTOMER_KEY = 'returning-customer-key';